<template>
  <div id="navigationBar">
    <!-- <div class="navbar-fixed">
      <nav class="grey darken-3">
        <a href="#" data-target="mobile-demo" class="sidenav-trigger"><i class="material-icons">menu</i></a>
        <div class="nav-wrapper navbar-margin">
          
          <div class="brand-logo left hide-on-med-and-down" >
            <a href="#"> 
              <img src="../assets/SmartX_Logo.png" width="150" height="auto" style="padding-top: 15px"> 
            </a>
          </div>

          <div class="brand-logo show-on-medium-and-down">
            <a href="#" > 
              <img src="../assets/SmartX_Logo.png" width="150" height="auto" style="padding-top: 15px"> 
            </a>
          </div>
          
          <ul id="nav-mobile" class="right hide-on-med-and-down">
            
            <li style="padding-right: 10px">
              <a href="tel:+49.40.30740117" style="font-size: 16px;"> <span style='font-weight: bold'> call: </span>  +49.40.30740117 </a>
            </li>

            <li style="padding-right: 10px">
              <a href="mailto:mail@smartXelements.de" style="font-size: 16px;"> <span style='font-weight: bold'> write: </span> mail@smartXelements.de </a>
            </li>
            
            <li v-if="!currentUser" style="padding-right: 10px">
              <button
                data-target="modal1"
                class="grey darken-3 navigationBarBtnBorder waves-effect waves-light btn modal-trigger"
              > {{ $t('navigationBar.login') }} </button>
            </li>
            
            <li v-if="currentUser" style="padding-right: 10px">
              <a class="waves-effect waves-light grey darken-3 navigationBarBtnBorder btn" v-on:click="menuBtnClicked">
                <i class="material-icons">account_circle</i>
              </a>
            </li>

            <li>
              <RadioToggleButtons v-model='currentLang' :values='langs'
                color='white'
                textColor='white'
                selectedTextColor='black'
              />
            </li>
          </ul> 
        </div>
      </nav>
    </div>

    <div class="divider"></div> 

    <ul class="sidenav grey darken-3 " id="mobile-demo">
      <li v-if="!currentUser" style="padding: 30px" class='center'>
        <button
          data-target="modal1"
          class="grey darken-3 navigationBarBtnBorder waves-effect waves-light btn modal-trigger sidenav-close"> {{ $t('navigationBar.login') }} 
        </button>
      </li>

      <li v-if="currentUser" style="padding: 30px" class='center'>
        <router-link to="/user" class="sidenav-close navigationBarBtnBorder white"> 
          Konto anzeigen 
        </router-link>
      </li>

      <li class='center'>
        <a href="tel:+49.40.30740117" class='white-text'> call: +49.40.30740117 </a>
      </li>
      <li class='center'>
        <a href="mailto:mail@smartXelements.de" class='white-text'>  write: mail@smartXelements.de </a>
      </li>
      <li style="padding: 30px" class='center'>
        <RadioToggleButtons v-model='currentLang' :values='langs'
          color='white'
          textColor='white'
          selectedTextColor='black'
        />
      </li>

      <li>
        <a class="grey-text text-lighten-4 " href="#!" style="padding-left: 30px"> {{ $t('websiteFooter.imprint') }} </a>
      </li>

      <li>
        <a class="grey-text text-lighten-4 " href="#!" style="padding-left: 30px"> {{ $t('websiteFooter.dataProtection') }} </a>
      </li>
      
      <li>
        <a class="grey-text text-lighten-4 " href="#!" style="padding-left: 30px"> {{ $t('websiteFooter.conditions') }} </a>
      </li>
    </ul>   
    <LoginUser /> -->

    <div class="navbar-fixed">
      <nav style="background-color: #292929">
        <a href="#" data-target="mobile-demo" class="sidenav-trigger right"><i class="material-icons">menu</i></a>
        <div class="navContainer nav-wrapper">
          
          <div class="brand-logo left">
            <a href="/" style="position: relative; top: 6px;"> 
              <img src="../assets/SmartX_Logo.png" width="141.6" height="35"> 
            </a>
          </div>
          
          <ul id="nav-mobile" class="right">
            
            <li>
              <a href="tel:+49.40.30740117" class="hide-on-med-and-down" style="font-size: 16px; color: #F0F0F0"> <span style='font-weight: bold'> call: </span>  +49.40.30740117 </a>
            </li>

            <li>
              <a href="tel:+49.40.30740117" class="hide-on-large-only" style="font-size: 16px; color: #F0F0F0; padding-right: 0px">  <i class="material-icons">call</i>  </a>
            </li>

            <li>
              <a href="mailto:mail@smartXelements.de" class="hide-on-med-and-down" style="font-size: 16px; color: #F0F0F0"> <span style='font-weight: bold'> write: </span> mail@smartXelements.de </a>
            </li>

            <li>
              <a href="mailto:mail@smartXelements.de" class="hide-on-large-only" style="font-size: 16px; color: #F0F0F0; padding-right: 0px"> <i class="material-icons">email</i>  </a>
            </li>
            
            <li v-if="!currentUser">
              <button 
                data-target="modal1"
                class="btn modal-trigger no-uppercase z-depth-0"
                style="font-size: 16px; background-color: #292929; color: #F0F0F0"
              > {{ $t('navigationBar.login') }} </button>
            </li>
            
            <li v-if="currentUser">
              <a class="btn-floating" v-on:click="menuBtnClicked" style="background-color: #292929">
                <!-- <i class="material-icons" style="font-size: 40px; background-color: #313131">account_circle</i> -->
                <img src="../assets/profileIcon.png" style="padding: 2px; background-color: #292929">
              </a>
            </li>

            <li v-if="currentLang == 'de'">
              <a href="#" @click="currentLang = 'de'" style="padding: 0px; text-decoration: underline; font-weight: bold; color: #F0F0F0"> DE </a>
            </li>
            <li v-else>
              <a href="#" @click="currentLang = 'de'" style="padding: 0px; color: #F0F0F0"> DE </a>
            </li>

            <li>
              <a href="#" style="padding-left: 5px; padding-right: 5px; color: #F0F0F0"> | </a>
            </li>

            <li v-if="currentLang == 'en'">
                <a href="#" @click="currentLang = 'en'" style="padding: 0px; text-decoration: underline; font-weight: bold; color: #F0F0F0"> EN </a>
            </li>
            <li v-else>
                <a href="#" @click="currentLang = 'en'" style="padding: 0px; color: #F0F0F0"> EN </a>
            </li>

          </ul> 
        </div>
        <div class="divider"></div> 
      </nav>
    </div>

    <ul class="sidenav" id="mobile-demo" style="background-color: #FAFAFA;">
      <li v-if="!currentUser" style="padding: 30px" class='center'>
        <button
          style="background-color: #292929; color: #FAFAFA"
          data-target="modal1"
          class="navigationBarBtnBorder btn modal-trigger sidenav-close"> {{ $t('navigationBar.login') }} 
        </button>
      </li>

      <li v-if="currentUser" style="padding: 30px" class='center'>
        <router-link to="/user" class="sidenav-close navigationBarBtnBorder white"> 
          Konto anzeigen 
        </router-link>
      </li>

      <li class='center'>
        <a href="tel:+49.40.30740117" style="color: #313131"> call: +49.40.30740117 </a>
      </li>
      <li class='center'>
        <a href="mailto:mail@smartXelements.de" style="color: #313131">  write: mail@smartXelements.de </a>
      </li>
      <li style="padding: 30px" class='center'>
        <RadioToggleButtons v-model='currentLang' :values='langs'
          color='#313131'
          textColor='#313131'
          selectedTextColor='#FAFAFA'
        />
      </li>
      <li class="center">
         <router-link to="/impressum" class="sidenav-close" style="font-size: 16px; padding-left: 10px; color: #313131"> {{ $t('websiteFooter.imprint') }} </router-link> 
      </li>

      <li class="center">
        <router-link to="/datenschutz" class="sidenav-close" style="font-size: 16px; padding-left: 10px; color: #313131"> {{ $t('websiteFooter.dataProtection') }} </router-link>
      </li>
    </ul>   
    <LoginUser />

  </div>
</template>

<script src='https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/js/materialize.min.js'></script>

<script>
import firebase from "firebase";
import LoginUser from "./LoginUser.vue";
export default {
  name: "navigationBar",

  data() {
    return {
      currentUser: null,
      currentUserEmail: null,
      langBtnDE: true,
      langBtnEN: false,

      langs: [
				{ label: 'DE', value: 'de' },
				{ label: 'EN', value: 'en' }
			],
			currentLang: 'de'
    };
  },


  computed: {
    isIdle() {
        return this.$store.state.idleVue.isIdle;
    }
  },

  watch:{
    currentLang(locale){
      import (`../langs/${locale}.json`).then((msgs) => {
        this.$i18n.setLocaleMessage(locale, msgs)
        this.$i18n.locale = locale
      })
    },

    isIdle() {
      if(this.$store.state.idleVue.isIdle == true && this.currentUser){
          firebase.auth().signOut().then(() => {
            this.$router.replace("/");
            window.location.reload();
          },
          error => {
            console.log(error);
          });
      }
    }
  },

  components: {
    LoginUser
  },

  mounted() {
    var elems = document.querySelectorAll('.sidenav');
    var instances = M.Sidenav.init(elems, {edge: 'right'});

    if(firebase.auth().currentUser) {
      this.currentUser = firebase.auth().currentUser;
      this.currentUserEmail = firebase.auth().currentUser.email;
    } else {
      console.log('No current user')
    }
  },

  methods: {
    menuBtnClicked() {
      this.$router.push("user");
    }
  }
};
</script>